import Vue from 'vue'
import App from './App.vue'
import router from './plugins/router'
import vuetify from './plugins/vuetify'
import "core-js/stable";
import "regenerator-runtime/runtime";
import Http401Middleware from '@/plugins/Http401Middleware'
import JwtMiddleware from '@/plugins/JwtMiddleware'
import LoadingMiddleware from '@/plugins/LoadingMiddleware'
import VuetifyMask from "vuetify-mask";
Vue.use(VuetifyMask);
import VuetifyMoney from "vuetify-money";
Vue.use(VuetifyMoney);

import  Vuelidate from 'vuelidate';   
Vue.use(Vuelidate);

import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("v-tippy", TippyComponent);
 

import VueMask from 'vue-the-mask'
Vue.use(VueMask)
Vue.component("v-mask",VueMask )

Vue.config.productionTip = false

LoadingMiddleware.config();
Http401Middleware.config();
JwtMiddleware.config();

var vueInstance =  new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')

export {vueInstance}